import React from 'react';
import { Form, InputNumber, Divider } from 'antd';
import { configShort } from '../../../../../common/utils/configFormField';

class Section6 extends React.Component {
  // constructor(props) {
  //     super(props);
  // }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { fields, disabledFields } = this.props;
    return (
      <div className="sectionFines">
        <Divider />
        <h1 className="header">
          Штрафы, уплачиваемые фрахтовщиком фрахтователю
        </h1>
        <div className="colsLayout">
          <span className="label">
            Непредоставление
            <br />
            фрахтовщиком ТС (Ш1), % от цены договора:
          </span>
          <Form.Item>
            {getFieldDecorator('section6_1', configShort(fields['section6_1']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Предоставление фрахтовщиком
            <br />
            ТС ненадлежащего качества (Ш1), % от цены договора:
          </span>
          <Form.Item>
            {getFieldDecorator('section6_2', configShort(fields['section6_2']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Отсутствие необходимых документов
            <br />
            перевозки у фрахтовщика (Ш1), % от цены договора:
          </span>
          <Form.Item>
            {getFieldDecorator('section6_3', configShort(fields['section6_3']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Нарушения фрахтовщиком правил
            <br />
            перевозки пассажиров (Ш1), % от цены договора:
          </span>
          <Form.Item>
            {getFieldDecorator('section6_4', configShort(fields['section6_4']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default Section6;
